import axios from "axios";
// config
import { HOST_API_KEY } from "../config-global";
// -----------------------------------------------------------------------

export const axiosInstance = axios.create({ baseURL: HOST_API_KEY, withCredentials: true });

axiosInstance.interceptors.response.use((response) => response.data.data);

axiosInstance.interceptors.request.use(
  async (config) => {
    config.headers.set("Content-Type", "application/json");

    return config;
  },
  async (error) => {
    return error;
  }
);

export default axiosInstance;
